export enum OrderStatus {
    NEW = "new",
    DRAFT = "draft",
    START_PAYMENT = "start payment",
    PAYMENT_FAILED = "payment failed",
    PART_PAYMENT = "part payment",
    PAYMENT_SUCCESS = "payment success",
    PAYMENT_PENDING = "payment in progress"
}